import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';


// Base protected route - ensures user is authenticated
export const ProtectedRoute = () => {
    const { currentUser } = useAuth();
    const location = useLocation();

    if (!currentUser) {
        // Redirect to login page if not authenticated
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

// Admin-specific routes
export const AdminRoute = () => {
    const { isAdmin } = useAuth();
    const location = useLocation();

    if (!isAdmin) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

// Vendor-specific routes
export const VendorRoute = () => {
    const { isVendor } = useAuth();
    const location = useLocation();

    if (!isVendor) {
        return <Navigate to="/vendor/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

// Teacher-specific routes
export const TeacherRoute = () => {
    const { isTeacher } = useAuth();
    const location = useLocation();

    if (!isTeacher) {
        return <Navigate to="/teacher/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

// College-specific routes
export const CollegeRoute = () => {
    const { isCollege } = useAuth();
    const location = useLocation();

    if (!isCollege) {
        return <Navigate to="/college/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

// Student-specific routes
export const StudentRoute = () => {
    const { isStudent } = useAuth();
    const location = useLocation();

    if (!isStudent) {
        return <Navigate to="/student/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};